import { render } from "./unlock-upsell.vue?vue&type=template&id=5e2c11d1&scoped=true"
import script from "./unlock-upsell.vue?vue&type=script&lang=js"
export * from "./unlock-upsell.vue?vue&type=script&lang=js"

import "./unlock-upsell.vue?vue&type=style&index=0&id=5e2c11d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2c11d1"]])

export default __exports__